import { OrganizationType } from '../models/Organization';

/**
 * Rehearsal studios cannot manage tutors (invite, onboard, assign).
 * Music schools, business orgs, and individual tutors use other surfaces.
 */
export function hostCanManageTutors(
  organizationType: OrganizationType | null | undefined,
): boolean {
  return organizationType !== OrganizationType.REHEARSAL_STUDIO;
}
